/*
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */

import DOMPurify from 'isomorphic-dompurify'

export interface RegistrationProps {
  url: string
}

export enum CommerceGridType {
  CATALOG_PRODUCT = 'product_listing',
  SALES_ORDER = 'sales_order_grid',
  CUSTOMER = 'customer_listing'
}

export function getRequestOptions(
  itemsLabel: string,
  items: FlatArray<any, any>
) {
  const formData = new FormData()
  formData.append(itemsLabel, JSON.stringify(items))
  formData.append('form_key', (window as any).FORM_KEY)
  return {
    method: 'POST',
    body: formData
  }
}

function validateAndSetHtmlByElementSelector(
  menuHtml: string,
  rootElmSelector: string
) {
  const rootElement = document.querySelector(rootElmSelector)
  if (rootElement) {
    const sanitizedMenuHtml = DOMPurify.sanitize(menuHtml)
    rootElement.innerHTML = sanitizedMenuHtml
  }
}

function activateGlobalNavigation(rootElmSelector: any) {
  const windowAsAny = window as any
  windowAsAny.jQuery(rootElmSelector).mage('globalNavigation')
}

export function updateMenu(
  url: string,
  rootElmSelector: string,
  menuItems: FlatArray<any, any>
) {
  fetch(url, getRequestOptions('menuItems', menuItems))
    .then((response) => response.text())
    .then(function (menuHtml) {
      validateAndSetHtmlByElementSelector(menuHtml, rootElmSelector)
      if (document.readyState === 'complete') {
        activateGlobalNavigation(rootElmSelector)
      } else {
        window.addEventListener('load', activateGlobalNavigation)
        return () =>
          window.removeEventListener('load', activateGlobalNavigation)
      }
    })
}
